import wizard from './init-wizard/handlers';
import auth from './modules/authentication/handlers';
import routing from './modules/routing/handlers';
import dashboard from './modules/dashboard/handlers';
import user from './modules/users/handlers';
import * as inventory from './modules/inventory/handlers';
import * as addressBook from './modules/address-book/handlers';
import * as dailyRental from './modules/daily-rental/handlers';
import * as content from './modules/content/handlers';
import * as email from './modules/email/handlers';
import * as settings from './modules/settings/handlers';

export default { wizard, auth, routing, dashboard, user, ...inventory, ...addressBook, ...dailyRental, ...content, ...email, ...settings };



// WEBPACK FOOTER //
// ./src/frontend/handlers.js